import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const CampaignRedirect = () => {
  const { campaignTag } = useParams<{ campaignTag: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (campaignTag) {
      // Save campaign tag to localStorage for tracking
      localStorage.setItem('campaign_tag', campaignTag);
      localStorage.setItem('assigned_campaign_tag', campaignTag);
      
      console.log(`Campaign redirect: ${campaignTag} saved to localStorage`);
      
      // Redirect to home page
      navigate('/', { replace: true });
    } else {
      // If no tag, just go to home
      navigate('/', { replace: true });
    }
  }, [campaignTag, navigate]);

  // Show loading while redirecting
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="animate-pulse text-muted-foreground">
        Przekierowywanie...
      </div>
    </div>
  );
};

export default CampaignRedirect;
